import { combineReducers } from 'redux';
import { BROKERBANS_PAY } from './types';
var brokerBansPay = function (state, action) {
    if (state === void 0) { state = { options: [], trans: {} }; }
    var payload = action.payload, type = action.type;
    switch (type) {
        case BROKERBANS_PAY:
            return payload;
        default:
            return state;
    }
};
export var SCOPE_NAME = 'PAY';
var PAY = combineReducers({
    brokerBansPay: brokerBansPay,
});
export default PAY;
